import React from 'react'
import { Route } from 'react-router-dom'
import Home from '../Home'
import Auth from '../Auth'

import './index.css'

const App = () => {
  return (
    <div className="container noselect">
      <Auth>
        <Route path="/" component={Home} />
      </Auth>
    </div>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App/index.js